export default __webpack_public_path__ + "static/media/Stop_running.cc8e2685.png";